module.exports = __webpack_public_path__ + "static/media/merriweather-regular-webfont.18fb7572.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-regular-webfont.woff2
// module id = 287
// module chunks = 0